import { ChartDrawLineData, ChartistBaseExtended, ChartTooltipPlugin } from 'models/chartist'

const $toolTip = document.querySelector('.chartist-tooltip') as HTMLElement

export default function chartTooltipPlugin(): ChartTooltipPlugin {
  return (chart) => {
    chart.on('draw', redrawChart)
    chart.container.addEventListener('mousemove', (event) => {
      handleTooltipValue(event, chart)
      setPosition(event)
    })
    chart.container.addEventListener('mouseleave', hide)
    chart.container.addEventListener('mouseenter', show)
  }
}

function setPosition(event: MouseEvent): void {
  $toolTip.style.left = `${event.clientX + 10}px`
  $toolTip.style.top = `${event.clientY - $toolTip.offsetHeight}px`
}

function appendIndicator(data: ChartDrawLineData) {
  const element = '<line x1="0" y1="0" x2="0.01" y2="0.01" class="ct-indicator"></line>'
  data.element._node.closest('.ct-series').insertAdjacentHTML('beforeend', element)
}

function drawIndicator(pointXValue: number, chart: ChartistBaseExtended) {
  // Unfortunately 'ct:value' can't be querySelector's selector
  const svgNode = chart.svg._node
  const line = svgNode.querySelector('.ct-indicator')
  line.setAttribute('x1', pointXValue.toString())
  line.setAttribute('x2', (pointXValue + 0.01).toString())
  line.setAttribute('y2', svgNode.clientHeight.toString())
}

function redrawChart(data: ChartDrawLineData): void {
  if (data.type === 'line') {
    appendIndicator(data)
    const pathElements = data.path.pathElements
    const points = data.element._node.closest('.ct-series').querySelectorAll('.ct-point')
    for (const [index, point] of points.entries()) {
      if (pathElements[index + 1]) {
        point.setAttribute('x2', pathElements[index + 1].x.toString())
        point.setAttribute('y2', pathElements[index + 1].y.toString())
      }
    }
  }
}

function handleTooltipValue(event: MouseEvent, chart: ChartistBaseExtended): void {
  const axisXValues = Array.from(chart.svg._node.querySelectorAll('.ct-point')).map((el: HTMLElement) =>
    parseFloat(el.getAttribute('x1')),
  )
  const closestXValue = axisXValues.sort((a, b) => Math.abs(a - event.offsetX) - Math.abs(b - event.offsetX))[0]
  const value = chart.svg._node.querySelector(`[x1="${closestXValue}"]`).getAttribute('ct:value')
  drawIndicator(closestXValue, chart)
  $toolTip.innerHTML = parseFloat(value).toFixed(4)
}

function hide(event: MouseEvent): void {
  const $indicator = (event.target as HTMLElement).querySelector('.ct-indicator')
  $indicator.classList.remove('is-visible')
  $toolTip.classList.remove('is-visible')
}

function show(event: MouseEvent): void {
  const $indicator = (event.target as HTMLElement).querySelector('.ct-indicator')
  $toolTip.classList.add('is-visible')
  $indicator.classList.add('is-visible')
}
